import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    location: _ctx.location,
    "max-width": _ctx.maxWidth
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_icon, _mergeProps(props, {
        size: _ctx.size,
        class: "info-tip",
        color: "grey-darken-1",
        tabindex: "0",
        role: "img",
        "aria-label": "説明",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["stop","prevent"]), ["space"]))
      }), {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" mdi-information-outline ", -1)
        ]))]),
        _: 1
      }, 16, ["size"])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.text), 1)
      ], true)
    ]),
    _: 3
  }, 8, ["location", "max-width"]))
}